<template>
    <div class="mx-auto max-w-3xl w-full px-3 md:px-0 h-full" v-touch:swipe.left="next" v-touch:swipe.right="prev">

        <!-- Question -->
       <div class="text-xl flex flex-items-start text-gray-800">
           <div class="flex items-center justify-center font-semibold mr-2 rounded-full"
                style="color: #2d3748; font-size:.9rem; background: #93bde0; width:30px; height:30px"
                v-text="(questionIndex + 1)"></div>
           <span v-html="question.question"></span>
       </div>
        <div class="mt-4 w-100 rounded p-1 border border-gray-300 d-flex justify-center" v-if="question.image">
            <img :src="question.public_path" :alt="question.id">
        </div>

        <!-- Answers -->
        <quiz-app-question-answers v-model="question" @score="userScore = $event"></quiz-app-question-answers>

        <!-- Controls -->
        <div class="flex fixed bottom-0 left-0 mt-12 py-3 px-3 bg-gray-200 border-t border-gray-400 w-full md:static md:bg-transparent md:border-transparent md:px-0 md:mt-4 md:py-0">
            <button @click="home()"
                    :title="__('Go Home')"
                    class="bg-gray-300 border border-gray-400 text-gray-700 px-1 py-1 text-2xl text-white font-semibold flex-1 mr-1 focus:outline-none md:p-0 hover:bg-gray-400">
                <i class="fas fa-home"></i>
                <span class="text-sm hidden md:block">{{ __('Home') }}</span>
            </button>
            <button @click="first()"
                    :disabled="isFirst"
                    :title="__('First Question')"
                    class="bg-gray-300 border border-gray-400 text-gray-700 px-1 py-1 text-2xl text-white font-semibold flex-1 mr-1 focus:outline-none md:p-0 hover:bg-gray-400">
                <i class="fas fa-angle-double-left"></i>
                <span class="text-sm hidden md:block">{{ __('First') }}</span>
            </button>
            <button @click="prev()"
                    :disabled="isFirst"
                    :title="__('Previous Question')"
                    class="bg-gray-300 border border-gray-400 text-gray-700 px-1 py-1 text-2xl text-white font-semibold flex-1 mr-1 focus:outline-none md:p-0 hover:bg-gray-400">
                <i class="fas fa-angle-left"></i>
                <span class="text-sm hidden md:block">{{ __('Previous') }}</span>
            </button>
            <button @click="next()"
                    :disabled="isLast"
                    :title="__('Next Question')"
                    class="bg-gray-300 border border-gray-400 text-gray-700 px-1 py-1 text-2xl text-white font-semibold flex-1 mr-1 focus:outline-none md:p-0 hover:bg-gray-400">
                <i class="fas fa-angle-right"></i>
                <span class="text-sm hidden md:block">{{ __('Next') }}</span>
            </button>
            <button @click="last()"
                    :disabled="isLast"
                    :title="__('Last Question')"
                    class="bg-gray-300 border border-gray-400 text-gray-700 px-1 py-1 text-2xl text-white font-semibold flex-1 mr-1 focus:outline-none md:p-0 hover:bg-gray-400">
                <i class="fas fa-angle-double-right"></i>
                <span class="text-sm hidden md:block">{{ __('Last') }}</span>
            </button>

            <button v-if="canCheckScore"
                    @click="checkScore()"
                    :title="__('Check your Score')"
                    class="bg-green-600 border border-gray-400 text-white px-1 py-1 text-2xl text-white font-semibold flex-1 mr-1 focus:outline-none md:p-0 hover:bg-green-700">
                <i class="fas fa-check-circle"></i>
                <span class="text-sm hidden md:block">{{ __('Check Score') }}</span>
            </button>
        </div>
    </div>
</template>
<script>
    export default {

        props: {
            questions: {
                type: Array,
                required: true
            },
            passingScore:{
                type: Number,
                required: true,
            },
            score: {
                type: Number,
                required: true,
            }
        },

        data() {
            return {
                userScore: this.score,
                question: this.questions[0],
            }
        },

        methods: {

            home(){
                App.bus.$emit('quiz-app-home');
            },

            first() {
                this.setCurrentQuestion(0)
            },

            prev() {
                if (this.isFirst) return;
                this.setCurrentQuestion(this.questionIndex - 1)
            },

            next() {
                if (this.isLast) return;
                this.setCurrentQuestion(this.questionIndex + 1)
            },

            last() {
                this.setCurrentQuestion(this.questions.length - 1)
            },

            setCurrentQuestion(index) {
                $("html, body").animate({scrollTop: 0}, "fast");
                this.question = this.questions[index];
            },

            checkScore() {

                var keys = JSON.parse(Storage.get('nlcaa-quiz-app'))

                App.request().put(`/api/quiz/check-score`, keys).then(response => {
                    if(response.data.completed){
                        Alert.timer(this.__('Congratulations! You have approved your Test!') + '<br><h1 class="qz-test-score">' + this.userScore + '%</h1>').then(() => {
                            Storage.forget('nlcaa-quiz-app');
                            this.refreshPage();
                        });
                    }else{
                        Alert.error(this.__(`You must receive at least ${response.data.passing_score}% to pass. Keep trying!`));
                    }
                }).catch(error => {
                    Alert.error(error.response.message)
                })
            }
        },

        computed: {

            isFirst() {
                return this.questionIndex == 0;
            },

            isLast() {
                return this.questionIndex == (this.questions.length - 1);
            },

            questionIndex() {
                return this.questions.findIndex(i => {
                    return i.id == this.question.id
                })
            },

            canCheckScore() {
                return this.questions.filter(question => {
                    return question.selected === null;
                }).length == 0;
            }
        }
    }
</script>
